import BasePage from "./basePage";
import SubController from "../subDeath/subController";
import { page2info } from "../subDeath/subpageInfo";
import SubIndex from "../subDeath/page2_index";
import Page2Sub1 from "../subDeath/page2_sub1";
import Page2Sub2 from "../subDeath/page2_sub2";
import Page2Sub3 from "../subDeath/page2_sub3";

export default class Page2 extends BasePage{
    constructor(info){
        super(info);
        super.set();

        this.ele = info.ele;
        page2info.subIndex.class = new SubIndex( page2info.subIndex );
        page2info.sub1.class = new Page2Sub1( page2info.sub1 );
        page2info.sub2.class = new Page2Sub2( page2info.sub2 );
        page2info.sub3.class = new Page2Sub3( page2info.sub3 );

        this.subController = new SubController( page2info );

        this._bindEvent();
    }

    _bindEvent(){
        $(this.ele).find('.list button').on('click', (e)=>{
            $(this.ele).find('.list li').removeClass('on');
            this.subController.change( e.currentTarget.getAttribute('data-key') );
        })
    }

    show(){
        super.show();
        this.subController.init('subIndex');
    }

    hide(){
        super.hide();
        this.subController.hide();
    }
}


// WEBPACK FOOTER //
// ./src/js/mainDeath/page2.js